export const serviceWorkflowMessages = {
  "Recommended by requester": { "es": "Recomendada por el solicitante", "ca": "Recomanada pel sol·licitant" },
  "Recommended quotation": { "es": "Cotización recomendada", "ca": "Cotització recomanada" },
  "Recommend this quotation": { "es": "Recomendar esta cotización", "ca": "Recomanar aquesta cotització" },
  "Mark the quotation you recommend. The order manager will make the final choice.": { "es": "Marca la cotización que recomiendas. Quien tramite la orden hará la elección definitiva.", "ca": "Marca la cotització que recomanes. Qui tramiti la comanda farà la tria definitiva." },
  "Service order created. Open Service orders from the menu to continue.": { "es": "Orden de servicio creada. Para continuar, abre Órdenes de servicio desde el menú.", "ca": "Comanda de servei creada. Per continuar, obre Ordres de servei des del menú." },
  "Requisition saved.": { "es": "Requisición guardada.", "ca": "Requisició desada." },
  "Service order saved.": { "es": "Orden de servicio guardada.", "ca": "Comanda de servei desada." },
  "New service requisition": { "es": "Nueva requisición de servicio", "ca": "Nova requisició de servei" },
  "Service requisition": { "es": "Requisición de servicio", "ca": "Requisició de servei" },
  "Review service order": { "es": "Revisar orden de servicio", "ca": "Revisar comanda de servei" },
  "Edit service order": { "es": "Editar orden de servicio", "ca": "Editar comanda de servei" },
  "Edit order": { "es": "Editar orden", "ca": "Editar comanda" },
  "Service confirmation": { "es": "Confirmación de servicio", "ca": "Confirmació de servei" },
  "Order overview": { "es": "Resumen de la orden", "ca": "Resum de la comanda" },
  "Service to confirm": { "es": "Servicio a confirmar", "ca": "Servei per confirmar" },
  "Service order": { "es": "Orden de servicio", "ca": "Comanda de servei" },
  "Choose a quotation below": { "es": "Elige una cotización de la comparativa", "ca": "Tria una cotització de la comparativa" },
  "Registration required before approval": { "es": "Requiere alta antes de solicitar aprobación", "ca": "Cal donar-lo d’alta abans de sol·licitar aprovació" },
  "Choose an active quotation on this requisition as the recommendation.": { "es": "Selecciona como recomendada una cotización activa de esta requisición.", "ca": "Selecciona com a recomanada una cotització activa d’aquesta requisició." },
  "The requester recommendation is preserved from the source requisition. Choose the order supplier instead.": { "es": "La recomendación del solicitante se conserva desde la requisición original. Elige el proveedor de la orden.", "ca": "La recomanació del sol·licitant es conserva des de la requisició original. Tria el proveïdor de la comanda." },
  "A clear title, the responsible department and the work to be done.": {
    "es": "Un título claro, el departamento responsable y el trabajo que se necesita.",
    "ca": "Un títol clar, el departament responsable i la feina que cal fer."
  },
  "Add quotation": {
    "es": "Añadir cotización",
    "ca": "Afegir cotització"
  },
  "Add the quotations you need. Each supplier has its own price, details and files.": {
    "es": "Añade las cotizaciones que necesites. Cada proveedor tiene su precio, sus detalles y sus archivos.",
    "ca": "Afegeix les cotitzacions que necessitis. Cada proveïdor té el seu preu, els detalls i els fitxers."
  },
  "Add your first quotation": {
    "es": "Añade la primera cotización",
    "ca": "Afegeix la primera cotització"
  },
  "Address": {
    "es": "Dirección",
    "ca": "Adreça"
  },
  "All changes saved": {
    "es": "Cambios guardados",
    "ca": "Canvis desats"
  },
  "Approval complete. The supplier receives only the selected service order.": {
    "es": "Aprobación completada. El proveedor recibirá únicamente la orden del servicio elegido.",
    "ca": "Aprovació completada. El proveïdor rebrà únicament l'ordre del servei escollit."
  },
  "At a glance": {
    "es": "Resumen",
    "ca": "Resum"
  },
  "Attachment": {
    "es": "Archivo adjunto",
    "ca": "Fitxer adjunt"
  },
  "Back to list": {
    "es": "Volver al listado",
    "ca": "Tornar al llistat"
  },
  "Browse files": {
    "es": "Elegir archivos",
    "ca": "Triar fitxers"
  },
  "Choose a registered supplier before requesting approval.": {
    "es": "Elige un proveedor registrado antes de solicitar aprobación.",
    "ca": "Tria un proveïdor registrat abans de sol·licitar aprovació."
  },
  "Choose a registered supplier or enter a supplier manually.": {
    "es": "Escoge un proveedor registrado o introduce uno manualmente.",
    "ca": "Tria un proveïdor registrat o introdueix-ne un manualment."
  },
  "Choose the quotation to order. The other quotations remain internal supporting documents.": {
    "es": "Elige la cotización que se contratará. Las demás se conservan como documentación interna de apoyo.",
    "ca": "Tria la cotització que es contractarà. Les altres es conserven com a documentació interna de suport."
  },
  "Choose this quotation": {
    "es": "Elegir esta cotización",
    "ca": "Triar aquesta cotització"
  },
  "Choose, approve and send": {
    "es": "Elegir, aprobar y enviar",
    "ca": "Triar, aprovar i enviar"
  },
  "Collect the quotation now; register the chosen supplier when ordering.": {
    "es": "Recoge ahora la cotización; da de alta al proveedor elegido al tramitar la orden.",
    "ca": "Recull ara la cotització; dona d'alta el proveïdor escollit en tramitar l'ordre."
  },
  "Company or professional": {
    "es": "Empresa o profesional",
    "ca": "Empresa o professional"
  },
  "Complete each quotation with a supplier, amount and attachment.": {
    "es": "Completa cada cotización con proveedor, importe y archivo adjunto.",
    "ca": "Completa cada cotització amb proveïdor, import i fitxer adjunt."
  },
  "Completed": {
    "es": "Finalizado",
    "ca": "Finalitzat"
  },
  "Confirm order": {
    "es": "Confirmar orden",
    "ca": "Confirmar ordre"
  },
  "Confirmation notes": {
    "es": "Notas de seguimiento",
    "ca": "Notes de seguiment"
  },
  "Contact person": {
    "es": "Persona de contacto",
    "ca": "Persona de contacte"
  },
  "Context for the people reviewing this service…": {
    "es": "Información para quienes revisarán este servicio…",
    "ca": "Informació per a qui revisarà aquest servei…"
  },
  "Convert a service requisition to create an order.": {
    "es": "Convierte una requisición de servicio para crear una orden.",
    "ca": "Converteix una requisició de servei per crear una ordre."
  },
  "Convert to service order": {
    "es": "Convertir en orden de servicio",
    "ca": "Convertir en ordre de servei"
  },
  "Converted": {
    "es": "Convertida",
    "ca": "Convertida"
  },
  "Create a requisition, describe the job and add the quotations you need.": {
    "es": "Crea una requisición, describe el trabajo y añade las cotizaciones que necesites.",
    "ca": "Crea una requisició, descriu la feina i afegeix les cotitzacions que necessitis."
  },
  "Cumulative progress (%)": {
    "es": "Avance acumulado (%)",
    "ca": "Avanç acumulat (%)"
  },
  "Define the work": {
    "es": "Definir el trabajo",
    "ca": "Definir la feina"
  },
  "Define the work and collect the quotations before creating an order.": {
    "es": "Describe el trabajo y reúne las cotizaciones antes de crear la orden.",
    "ca": "Descriu la feina i reuneix les cotitzacions abans de crear l'ordre."
  },
  "Describe the job, the expected result and any important requirements…": {
    "es": "Describe el trabajo, el resultado esperado y los requisitos importantes…",
    "ca": "Descriu la feina, el resultat esperat i els requisits importants…"
  },
  "Direct sending is allowed. Confirm the order, then send it to the supplier.": {
    "es": "El envío directo está permitido. Confirma la orden y después envíala al proveedor.",
    "ca": "L'enviament directe està permès. Confirma l'ordre i després envia-la al proveïdor."
  },
  "Document history and approvals": {
    "es": "Historial del documento y aprobaciones",
    "ca": "Historial del document i aprovacions"
  },
  "Documents attached.": {
    "es": "Archivos adjuntados.",
    "ca": "Fitxers adjuntats."
  },
  "Draft not saved": {
    "es": "Borrador sin guardar",
    "ca": "Esborrany sense desar"
  },
  "Draft saved.": {
    "es": "Borrador guardado.",
    "ca": "Esborrany desat."
  },
  "Drop files here": {
    "es": "Arrastra los archivos aquí",
    "ca": "Arrossega els fitxers aquí"
  },
  "Enter a date and a valid cumulative percentage. Completed work must be 100%.": {
    "es": "Introduce una fecha y un porcentaje acumulado válido. El trabajo finalizado debe estar al 100 %.",
    "ca": "Introdueix una data i un percentatge acumulat vàlid. La feina finalitzada ha d'estar al 100 %."
  },
  "Enter a title, choose a department and describe the work.": {
    "es": "Introduce un título, elige un departamento y describe el trabajo.",
    "ca": "Introdueix un títol, tria un departament i descriu la feina."
  },
  "Enter supplier manually": {
    "es": "Introducir proveedor manualmente",
    "ca": "Introduir proveïdor manualment"
  },
  "Enter the supplier name and a valid email address.": {
    "es": "Introduce el nombre del proveedor y un correo válido.",
    "ca": "Introdueix el nom del proveïdor i un correu vàlid."
  },
  "Execution date": {
    "es": "Fecha de ejecución",
    "ca": "Data d'execució"
  },
  "Execution progress": {
    "es": "Seguimiento de ejecución",
    "ca": "Seguiment d'execució"
  },
  "For example: repair the main lift": {
    "es": "Por ejemplo: reparación del ascensor principal",
    "ca": "Per exemple: reparació de l'ascensor principal"
  },
  "In progress": {
    "es": "En curso",
    "ca": "En curs"
  },
  "Internal documents for this service, separate from each quotation.": {
    "es": "Documentos internos del servicio, separados de cada cotización.",
    "ca": "Documents interns del servei, separats de cada cotització."
  },
  "Internal notes": {
    "es": "Notas internas",
    "ca": "Notes internes"
  },
  "Link existing supplier": {
    "es": "Vincular proveedor existente",
    "ca": "Vincular proveïdor existent"
  },
  "Manual supplier": {
    "es": "Proveedor sin registrar",
    "ca": "Proveïdor sense registrar"
  },
  "New requisition": {
    "es": "Nueva requisición",
    "ca": "Nova requisició"
  },
  "New supplier": {
    "es": "Nuevo proveedor",
    "ca": "Nou proveïdor"
  },
  "No execution updates yet.": {
    "es": "Todavía no hay registros de ejecución.",
    "ca": "Encara no hi ha registres d'execució."
  },
  "No matching documents": {
    "es": "No hay documentos coincidentes",
    "ca": "No hi ha documents coincidents"
  },
  "No service orders yet": {
    "es": "Todavía no hay órdenes de servicio",
    "ca": "Encara no hi ha ordres de servei"
  },
  "No services awaiting confirmation": {
    "es": "No hay servicios pendientes de confirmar",
    "ca": "No hi ha serveis pendents de confirmar"
  },
  "Not started": {
    "es": "Sin iniciar",
    "ca": "Sense iniciar"
  },
  "Open": {
    "es": "Abrir",
    "ca": "Obrir"
  },
  "Open attachment": {
    "es": "Abrir archivo",
    "ca": "Obrir fitxer"
  },
  "Optional": {
    "es": "Opcional",
    "ca": "Opcional"
  },
  "Order": {
    "es": "Orden",
    "ca": "Ordre"
  },
  "Order amount": {
    "es": "Importe de la orden",
    "ca": "Import de l'ordre"
  },
  "Order rejected.": {
    "es": "Orden rechazada.",
    "ca": "Ordre rebutjada."
  },
  "Order responsible": {
    "es": "Responsable de la orden",
    "ca": "Responsable de l'ordre"
  },
  "Order returned for correction.": {
    "es": "Orden devuelta para corregir.",
    "ca": "Ordre retornada per corregir."
  },
  "Orders appear here after they have been sent to the supplier.": {
    "es": "Las órdenes aparecen aquí después de enviarse al proveedor.",
    "ca": "Les ordres apareixen aquí després d'enviar-se al proveïdor."
  },
  "PDF or images · up to 20 MB per file": {
    "es": "PDF o imágenes · hasta 20 MB por archivo",
    "ca": "PDF o imatges · fins a 20 MB per fitxer"
  },
  "Phone": {
    "es": "Teléfono",
    "ca": "Telèfon"
  },
  "Planned service date": {
    "es": "Fecha prevista del servicio",
    "ca": "Data prevista del servei"
  },
  "Preview supplier PDF": {
    "es": "Ver PDF para el proveedor",
    "ca": "Veure PDF per al proveïdor"
  },
  "Progress": {
    "es": "Avance",
    "ca": "Avanç"
  },
  "Quotation": {
    "es": "Cotización",
    "ca": "Cotització"
  },
  "Quotation details": {
    "es": "Detalles de la cotización",
    "ca": "Detalls de la cotització"
  },
  "Quotations": {
    "es": "Cotizaciones",
    "ca": "Cotitzacions"
  },
  "Record progress": {
    "es": "Registrar avance",
    "ca": "Registrar avanç"
  },
  "Record service progress": {
    "es": "Registrar ejecución",
    "ca": "Registrar execució"
  },
  "Record the actual date and cumulative completion of the work.": {
    "es": "Registra la fecha real y el grado de avance acumulado del trabajo.",
    "ca": "Registra la data real i el grau d'avanç acumulat de la feina."
  },
  "Record when the work happens and how far it has progressed.": {
    "es": "Registra cuándo se realiza el trabajo y su grado de avance.",
    "ca": "Registra quan es fa la feina i el seu grau d'avanç."
  },
  "Register or link this supplier before requesting approval.": {
    "es": "Da de alta o vincula este proveedor antes de solicitar aprobación.",
    "ca": "Dona d'alta o vincula aquest proveïdor abans de sol·licitar aprovació."
  },
  "Register service supplier": {
    "es": "Alta de proveedor de servicios",
    "ca": "Alta de proveïdor de serveis"
  },
  "Register supplier": {
    "es": "Dar de alta al proveedor",
    "ca": "Donar d'alta el proveïdor"
  },
  "Registered supplier": {
    "es": "Proveedor registrado",
    "ca": "Proveïdor registrat"
  },
  "Requisition": {
    "es": "Requisición",
    "ca": "Requisició"
  },
  "Save the supplier details before attaching a quotation.": {
    "es": "Guarda los datos del proveedor antes de adjuntar la cotización.",
    "ca": "Desa les dades del proveïdor abans d'adjuntar la cotització."
  },
  "Search code, title, department or supplier": {
    "es": "Buscar código, título, departamento o proveedor",
    "ca": "Cercar codi, títol, departament o proveïdor"
  },
  "Select the supplier, complete approval and send the service order.": {
    "es": "Elige el proveedor, completa la aprobación y envía la orden de servicio.",
    "ca": "Tria el proveïdor, completa l'aprovació i envia l'ordre de servei."
  },
  "Selected quotation": {
    "es": "Cotización elegida",
    "ca": "Cotització escollida"
  },
  "Selected supplier": {
    "es": "Proveedor elegido",
    "ca": "Proveïdor escollit"
  },
  "Send service order": {
    "es": "Enviar orden de servicio",
    "ca": "Enviar ordre de servei"
  },
  "Send to supplier": {
    "es": "Enviar al proveedor",
    "ca": "Enviar al proveïdor"
  },
  "Sending is being processed. Refresh to check its status.": {
    "es": "El envío está en curso. Actualiza para comprobar su estado.",
    "ca": "L'enviament està en curs. Actualitza per comprovar-ne l'estat."
  },
  "Sending permissions and approval limits use the selected quotation amount.": {
    "es": "Los permisos de envío y los límites de aprobación se aplican al importe de la cotización elegida.",
    "ca": "Els permisos d'enviament i els límits d'aprovació s'apliquen a l'import de la cotització escollida."
  },
  "Sending…": {
    "es": "Enviando…",
    "ca": "Enviant…"
  },
  "Sent to supplier": {
    "es": "Enviada al proveedor",
    "ca": "Enviada al proveïdor"
  },
  "Service confirmations": {
    "es": "Confirmaciones de servicio",
    "ca": "Confirmacions de servei"
  },
  "Service details": {
    "es": "Datos del servicio",
    "ca": "Dades del servei"
  },
  "Service order sent to the supplier.": {
    "es": "Orden de servicio enviada al proveedor.",
    "ca": "Ordre de servei enviada al proveïdor."
  },
  "Service orders": {
    "es": "Órdenes de servicio",
    "ca": "Ordres de servei"
  },
  "Service overview": {
    "es": "Resumen del servicio",
    "ca": "Resum del servei"
  },
  "Service progress recorded.": {
    "es": "Avance del servicio registrado.",
    "ca": "Avanç del servei registrat."
  },
  "Service purchasing": {
    "es": "Compras de servicios",
    "ca": "Compres de serveis"
  },
  "Service requisitions": {
    "es": "Requisiciones de servicio",
    "ca": "Requisicions de servei"
  },
  "Service title": {
    "es": "Título del servicio",
    "ca": "Títol del servei"
  },
  "Service workflow": {
    "es": "Proceso de servicios",
    "ca": "Procés de serveis"
  },
  "Supplier": {
    "es": "Proveedor",
    "ca": "Proveïdor"
  },
  "Supplier email": {
    "es": "Correo del proveedor",
    "ca": "Correu del proveïdor"
  },
  "Supplier name": {
    "es": "Nombre del proveedor",
    "ca": "Nom del proveïdor"
  },
  "Supplier quotations": {
    "es": "Cotizaciones de proveedores",
    "ca": "Cotitzacions de proveïdors"
  },
  "Supplier registered and linked.": {
    "es": "Proveedor registrado y vinculado.",
    "ca": "Proveïdor registrat i vinculat."
  },
  "Supplier selection": {
    "es": "Selección del proveedor",
    "ca": "Selecció del proveïdor"
  },
  "Tax ID": {
    "es": "NIF / Identificación fiscal",
    "ca": "NIF / Identificació fiscal"
  },
  "The only quotation is selected automatically.": {
    "es": "Al haber una sola cotización, queda elegida automáticamente.",
    "ca": "Com que hi ha una sola cotització, queda escollida automàticament."
  },
  "The order is approved and ready to send to the supplier.": {
    "es": "La orden está aprobada y lista para enviar al proveedor.",
    "ca": "L'ordre està aprovada i a punt per enviar al proveïdor."
  },
  "The previous delivery could not be confirmed. Sending again may deliver a duplicate email.": {
    "es": "No se pudo confirmar el envío anterior. Al reenviar, el proveedor podría recibir un correo duplicado.",
    "ca": "No s'ha pogut confirmar l'enviament anterior. En tornar a enviar, el proveïdor podria rebre un correu duplicat."
  },
  "The service order could not be sent. Review the delivery details before retrying.": {
    "es": "No se pudo enviar la orden de servicio. Revisa el detalle del envío antes de reintentarlo.",
    "ca": "No s'ha pogut enviar l'ordre de servei. Revisa el detall de l'enviament abans de tornar-ho a intentar."
  },
  "The supplier receives the service order PDF. Competing quotations and internal notes are not included.": {
    "es": "El proveedor recibirá el PDF de la orden de servicio. No se incluyen otras cotizaciones ni las notas internas.",
    "ca": "El proveïdor rebrà el PDF de l'ordre de servei. No s'hi inclouen altres cotitzacions ni les notes internes."
  },
  "This creates a service supplier and links it to the selected quotation.": {
    "es": "Se dará de alta un proveedor de servicios y se vinculará a la cotización elegida.",
    "ca": "Es donarà d'alta un proveïdor de serveis i es vincularà a la cotització escollida."
  },
  "Track the work": {
    "es": "Confirmar la ejecución",
    "ca": "Confirmar l'execució"
  },
  "Try another search or status filter.": {
    "es": "Prueba otra búsqueda o filtro de estado.",
    "ca": "Prova una altra cerca o filtre d'estat."
  },
  "Unsaved changes": {
    "es": "Cambios sin guardar",
    "ca": "Canvis sense desar"
  },
  "Untitled service": {
    "es": "Servicio sin título",
    "ca": "Servei sense títol"
  },
  "View service order": {
    "es": "Ver orden de servicio",
    "ca": "Veure ordre de servei"
  },
  "View source requisition": {
    "es": "Ver requisición original",
    "ca": "Veure requisició original"
  },
  "What is included, conditions and useful details…": {
    "es": "Qué incluye, condiciones y detalles útiles…",
    "ca": "Què inclou, condicions i detalls útils…"
  },
  "Work completed, pending items or observations…": {
    "es": "Trabajo realizado, tareas pendientes u observaciones…",
    "ca": "Feina feta, tasques pendents o observacions…"
  },
  "Work to be done": {
    "es": "Trabajo o servicio a realizar",
    "ca": "Feina o servei a fer"
  },
  "Your next service starts here": {
    "es": "Tu próximo servicio empieza aquí",
    "ca": "El teu proper servei comença aquí"
  },
  "documents": {
    "es": "documentos",
    "ca": "documents"
  },
  "Created from requisition": {
    "es": "Creada desde requisición",
    "ca": "Creada des de requisició"
  },
  "Supplier registered": {
    "es": "Proveedor dado de alta",
    "ca": "Proveïdor donat d’alta"
  },
  "Approval not required": {
    "es": "Aprobación no requerida",
    "ca": "Aprovació no requerida"
  },
  "Supplier delivery requested": {
    "es": "Envío al proveedor solicitado",
    "ca": "Enviament al proveïdor sol·licitat"
  },
  "Supplier delivery failed": {
    "es": "Envío al proveedor fallido",
    "ca": "Enviament al proveïdor fallit"
  },
  "Supplier delivery unconfirmed": {
    "es": "Envío al proveedor sin confirmar",
    "ca": "Enviament al proveïdor sense confirmar"
  },
  "Service progress recorded": {
    "es": "Avance del servicio registrado",
    "ca": "Avanç del servei registrat"
  },
  "Service completed": {
    "es": "Servicio finalizado",
    "ca": "Servei finalitzat"
  },
  "Return this order for correction if the selected quotation needs to change.": {
    "es": "Devuelve esta orden para corregir si hay que cambiar la cotización elegida.",
    "ca": "Retorna aquesta ordre per corregir si cal canviar la cotització escollida."
  },
  "This supplier already exists but is inactive. Activate it and enable service purchasing in Suppliers before linking it.": {
    "es": "Este proveedor ya existe, pero está inactivo. Actívalo y habilita la compra de servicios en Proveedores antes de vincularlo.",
    "ca": "Aquest proveïdor ja existeix, però està inactiu. Activa'l i habilita la compra de serveis a Proveïdors abans de vincular-lo."
  },
  "This supplier already exists. Enable service purchasing in Suppliers before linking it; its stock supplier setting must be retained.": {
    "es": "Este proveedor ya existe. Habilita la compra de servicios en Proveedores antes de vincularlo; debe conservar su condición de proveedor de stock.",
    "ca": "Aquest proveïdor ja existeix. Habilita la compra de serveis a Proveïdors abans de vincular-lo; ha de conservar la condició de proveïdor d'estoc."
  },
  "This supplier already exists. Link the existing supplier to this quotation.": {
    "es": "Este proveedor ya existe. Vincula el proveedor existente a esta cotización.",
    "ca": "Aquest proveïdor ja existeix. Vincula el proveïdor existent a aquesta cotització."
  },
  "Add a valid email address to the selected supplier before sending this order.": {
    "es": "Añade un correo válido al proveedor elegido antes de enviar esta orden.",
    "ca": "Afegeix un correu vàlid al proveïdor escollit abans d'enviar aquesta ordre."
  },
  "This order is already being sent. Reopen it to check the result.": {
    "es": "Esta orden ya se está enviando. Vuelve a abrirla para comprobar el resultado.",
    "ca": "Aquesta ordre ja s'està enviant. Torna-la a obrir per comprovar el resultat."
  },
  "The previous delivery could not be confirmed. Review it before confirming another send.": {
    "es": "No se pudo confirmar el envío anterior. Revísalo antes de confirmar otro envío.",
    "ca": "No s'ha pogut confirmar l'enviament anterior. Revisa'l abans de confirmar un altre enviament."
  },
  "You do not have permission for this service action.": {
    "es": "No tienes permiso para realizar esta acción del servicio.",
    "ca": "No tens permís per fer aquesta acció del servei."
  },
  "Approve the service order before sending it.": {
    "es": "Aprueba la orden de servicio antes de enviarla.",
    "ca": "Aprova l'ordre de servei abans d'enviar-la."
  },
  "Send the approved service order before recording execution.": {
    "es": "Envía la orden de servicio aprobada antes de registrar su ejecución.",
    "ca": "Envia l'ordre de servei aprovada abans de registrar-ne l'execució."
  },
  "This service has already been completed. Reopen it to see the latest progress.": {
    "es": "Este servicio ya está finalizado. Vuelve a abrirlo para ver el último avance.",
    "ca": "Aquest servei ja està finalitzat. Torna'l a obrir per veure l'últim avanç."
  },
  "Enter a valid execution date.": {
    "es": "Introduce una fecha de ejecución válida.",
    "ca": "Introdueix una data d'execució vàlida."
  },
  "Enter valid progress between 0 and 100. Completed work must be 100%.": {
    "es": "Introduce un avance válido entre 0 y 100. El trabajo finalizado debe estar al 100 %.",
    "ca": "Introdueix un avanç vàlid entre 0 i 100. La feina finalitzada ha d'estar al 100 %."
  },
  "Cumulative progress cannot be lower than the last recorded progress.": {
    "es": "El avance acumulado no puede ser inferior al último avance registrado.",
    "ca": "L'avanç acumulat no pot ser inferior a l'últim avanç registrat."
  },
  "The execution date cannot be earlier than the latest recorded update.": {
    "es": "La fecha de ejecución no puede ser anterior al último registro.",
    "ca": "La data d'execució no pot ser anterior a l'últim registre."
  },
  "This action has already been recorded with different details. Reopen the order before continuing.": {
    "es": "Esta acción ya se registró con otros datos. Vuelve a abrir la orden antes de continuar.",
    "ca": "Aquesta acció ja es va registrar amb altres dades. Torna a obrir l'ordre abans de continuar."
  },
  "Reopen the order and try the action again.": {
    "es": "Vuelve a abrir la orden e inténtalo de nuevo.",
    "ca": "Torna a obrir l'ordre i torna-ho a intentar."
  },
  "Configure the service approval policy in Settings before submitting this order.": {
    "es": "Configura las aprobaciones de servicios en Settings antes de enviar esta orden.",
    "ca": "Configura les aprovacions de serveis a Settings abans d'enviar aquesta ordre."
  }
};

export const serviceWorkflowErrors = {
  SERVICE_RECOMMENDED_QUOTATION_INVALID: "Choose an active quotation on this requisition as the recommendation.",
  SERVICE_RECOMMENDATION_READ_ONLY: "The requester recommendation is preserved from the source requisition. Choose the order supplier instead.",
  "SERVICE_SUPPLIER_INACTIVE": "This supplier already exists but is inactive. Activate it and enable service purchasing in Suppliers before linking it.",
  "SERVICE_SUPPLIER_SERVICE_DISABLED": "This supplier already exists. Enable service purchasing in Suppliers before linking it; its stock supplier setting must be retained.",
  "SERVICE_SUPPLIER_ALREADY_EXISTS": "This supplier already exists. Link the existing supplier to this quotation.",
  "SERVICE_SUPPLIER_EMAIL_REQUIRED": "Add a valid email address to the selected supplier before sending this order.",
  "SERVICE_DELIVERY_IN_PROGRESS": "This order is already being sent. Reopen it to check the result.",
  "SERVICE_DELIVERY_RETRY_CONFIRMATION_REQUIRED": "The previous delivery could not be confirmed. Review it before confirming another send.",
  "SERVICE_DELIVERY_RESULT_UNCERTAIN": "The previous delivery could not be confirmed. Review it before confirming another send.",
  "SERVICE_OPERATION_FORBIDDEN": "You do not have permission for this service action.",
  "SERVICE_ORDER_APPROVAL_REQUIRED": "Approve the service order before sending it.",
  "SERVICE_ORDER_NOT_SENT": "Send the approved service order before recording execution.",
  "SERVICE_ORDER_ALREADY_COMPLETED": "This service has already been completed. Reopen it to see the latest progress.",
  "SERVICE_CONFIRMATION_DATE_INVALID": "Enter a valid execution date.",
  "SERVICE_CONFIRMATION_PROGRESS_INVALID": "Enter valid progress between 0 and 100. Completed work must be 100%.",
  "SERVICE_CONFIRMATION_PROGRESS_DECREASE": "Cumulative progress cannot be lower than the last recorded progress.",
  "SERVICE_CONFIRMATION_DATE_DECREASE": "The execution date cannot be earlier than the latest recorded update.",
  "SERVICE_IDEMPOTENCY_CONFLICT": "This action has already been recorded with different details. Reopen the order before continuing.",
  "SERVICE_IDEMPOTENCY_KEY_REQUIRED": "Reopen the order and try the action again.",
  "SERVICE_APPROVAL_POLICY_REQUIRED": "Configure the service approval policy in Settings before submitting this order."
};
